import React, { Component } from "react";
import {
    Grid,
    Row,
    Pagination,
    Col,
    Table,
    OverlayTrigger,
    ControlLabel,
    FormGroup,
    FormControl,
    Modal,
    Tooltip,
} from "react-bootstrap";
import {
    Updatereview,
    getallrider,
    ChargeOrder,
    getallCurrier,
    searchUpcomingOrders,
    DeleteOrder,
    DownloadOrder,
    updatepaymentinfo,
    getCity,
    getb2b,
    sendNotificationSMS,
    get_normal_pending_order,
    get_express_pending_order,
} from "../../../Listfunction";

import Datetime from "react-datetime";
import "react-datepicker/dist/react-datepicker.css";
import SweetAlert from "react-bootstrap-sweetalert";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import Card from "components/Card/Card.jsx";
import LoadingSpinner from "views/Components/loadingSpinner";
import LoadingPdfSpinner from "views/Components/loadingPdfSpinner";
import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import { getApiErrorMessage } from "utils/getApiErrorMessage";
const moment = extendMoment(originalMoment);

class upcomingOrder extends Component {
    constructor(props) {
        super(props);
        const today = moment();
        this.state = {
            pdfloading: false,
            order_details: [],
            order_chk: [],
            selected_id: [],
            order_info: [],
            loading: false,
            bulkSelect: null,
            subscriber: "",
            rider_id: "",
            currier_id: null,
            is_currier: null,
            source: "",
            status: "",
            page: "",
            paginationData: [],
            show_charge_message: false,
            charge_message: "",
            noRecordFound: false,
            nextpage: "",
            city_info: [],
            prevpage: "",
            currentPage: 1,
            nextdisabled: "1",
            prevdisabled: "1",
            deliveryType: "",
            alert: null,
            viewinvoice: "",
            useraccess: "",
            orderdate: "",
            processing: true,
            smsMessage: "",
            showSmsMessageModal: false,
            btn_disabled: true,
            channel_filter: "",
            order_type_filter: "",
            order_id_filter: "",
            fromdate_filter: "",
            todate_filter: "",
            todateerror: null,
            p_orderid: "",
            p_orderdata: [],
            chargeProcessing: false,
            p_total_cost: "",
            p_paid_amount: "",
            showpaymentdetailmodal: false,
            shownotificationmodal: false,
            _notificationSystem: null,
            paymenttype: "",
            f_paymenttype: "",
            remainpaymentamount: "0",
            paidamount: 0,
            errormessages: [],
            cancelorderModal: false,
            ridermodel: false,
            ordercancelreason: "",
            paymentoption: "",
            city_id: 0,
            notificationtype: "delay",
            cancel_reason_display_Modal: false,
            Cancel_reason_state: "",
            ordercancelreasonError: null,
            rider_details: [],
            currier_details: [],
            b2b: "",
            b2bDetails: [],
            rider_info: null,
            rider_infoError: null,
            currier_idError: null,
            rider_data: [],
            currier_data: [],
            value: "",
            isdaterangepickerOpen: false,
            rider_details: [],
            time: "",
            currier_disabled: "yes",
            btn_text: "Submit",
            htmlContent: "",
            notedisplay: [],
            normal_data: [],
            express_data: [],
            is_checked: [],
            deliverydate: new Date(),
            datarange: moment.range(today.clone().subtract(7, "days"), today.clone()),
            isdatepickeron: false,
            delivery_from_date: "",
            delivery_to_date: "",
        };
        this.editOrder = this.editOrder.bind(this);
        this.searchData = this.searchData.bind(this);
        this.searchdata = this.searchdata.bind(this);
        this.resetSearch = this.resetSearch.bind(this);
        this.onChange = this.onChange.bind(this);
        this.getdata = this.getdata.bind(this);
        this.deleteorderdetails = this.deleteorderdetails.bind(this);
        this.warningWithConfirmAndCancelMessage =
            this.warningWithConfirmAndCancelMessage.bind(this);
        this.downloadinvoice = this.downloadinvoice.bind(this);
        this.viewpdf = this.viewpdf.bind(this);
        this.onpaymentchange = this.onpaymentchange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.downloadpre = this.downloadpre.bind(this);
        this.oncancelchnage = this.oncancelchnage.bind(this);
    }

    chargeSubscription(id) {
        this.setState({
            chargeProcessing: true,
        });
        // const FileDownload = require('js-file-download');
        var token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        ChargeOrder(id, obj)
            .then((res) => {
                this.setState({
                    alert: null,
                });
                this.setState({
                    show_charge_message: true,
                    charge_message: res.data.message,
                    chargeProcessing: false,
                });

                this.searchData(this.state.deliverydate);
            })
            .catch((error) => {
                this.handleNetworkError("bl", error);
            });
    }

    warningWithChargeMessage(id) {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{ display: "block", marginTop: "-100px" }}
                    title="Are you sure?"
                    onConfirm={() => this.chargeSubscription(id)}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="info"
                    cancelBtnBsStyle="danger"
                    confirmBtnText="Yes, charge it!"
                    cancelBtnText="Cancel"
                    showCancel
                >
                    You will charge for that Order now !
                </SweetAlert>
            ),
        });
    }

    open_cancel_reason_display_Modal(cancel_reason) {
        this.setState({
            cancel_reason_display_Modal: true,
            Cancel_reason_state: cancel_reason,
        });
    }

    close_cancel_reason_display_Modal() {
        this.setState({
            cancel_reason_display_Modal: false,
            Cancel_reason_state: "",
        });
    }

    warningWithSendNotification() {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{ display: "block", marginTop: "-100px" }}
                    title="Are you sure you want send SMS/PN?"
                    onConfirm={() => this.submitNotificationModal()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="info"
                    cancelBtnBsStyle="danger"
                    confirmBtnText="Yes, Send it!"
                    cancelBtnText="Cancel"
                    showCancel
                >
                    SMS / PN will be sent to the customer
                </SweetAlert>
            ),
        });
    }

    warningWithConfirmAndCancelMessage(id) {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{ display: "block", marginTop: "-100px" }}
                    title="Are you sure?"
                    onConfirm={() => this.deleteorderdetails(id)}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="info"
                    cancelBtnBsStyle="danger"
                    confirmBtnText="Yes, delete it!"
                    cancelBtnText="Cancel"
                    showCancel
                >
                    You will not be able to recover this Order Detail !
                </SweetAlert>
            ),
        });
    }

    downloadpre(url) {
        if (url != "") {
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", url);
            // document.body.appendChild(link)
            link.click();
        } else {
            this.setState({
                alert: (
                    <SweetAlert
                        style={{ display: "block", marginTop: "-100px" }}
                        onConfirm={() => this.hideAlert()}
                        onCancel={() => this.hideAlert()}
                        confirmBtnBsStyle="info"
                    >
                        <h3>No prescription uploaded!</h3>
                    </SweetAlert>
                ),
            });
            // alert("No prescription uploaded")
        }
    }

    hideAlert() {
        this.setState({
            alert: null,
        });
    }

    downloadinvoice(id) {
        // const FileDownload = require('js-file-download');
        var token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        this.setState({ pdfloading: true, processing: false }, () => {
            DownloadOrder(id, obj).then((res) => {
                this.setState({ pdfloading: false });
                var ddata = res.data.data.pdf_url;
                // const url = ddata;
                // axio
                // download(ddata.data,file.file_name,content)
                // FileDownload(ddata,'order_'+id+'.pdf')
                // const url = window.URL.createObjectURL(new Blob([res.data]))
                // console.log(url);
                const link = document.createElement("a");
                link.href = ddata;
                link.target = "_blank";
                link.setAttribute("download", "order_" + id + ".pdf");
                // document.body.appendChild(link)
                link.click();
                // this.setState({
                //   viewinvoice : ddata
                // })
                this.setState({ pdfloading: false, processing: true });
            });
        });
    }

    viewpdf(id) {
        var token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        this.setState({ pdfloading: true }, () => {
            DownloadOrder(id, obj).then((res) => {
                this.setState({
                    //    pdfloading: false,
                });
                var ddata = res.data.data.pdf_url;
                return <a href={ddata} target="_balnk"></a>;
            });
        });
    }

    deleteorderdetails(id) {
        var token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        DeleteOrder(id, obj)
            .then((res) => {
                this.setState({
                    alert: null,
                });
                this.searchData(this.state.deliverydate);
            })
            .catch((error) => {
                this.handleNetworkError("bl", error);
            });
    }

    getdata(url) {
        this.setState({ page: url });
        this.searchData(this.state.deliverydate);
    }

    onChange = (event) => {
        const target = event.target;
        const value = target.type === "select" ? target.selected : target.value;
        // const value = target.type === 'datetime' ? target.Datetime : target.value;
        const name = target.name;
        this.setState({
            [name]: value,
        });

        this.searchdata();
    };

    oncancelchnage = (event) => {
        const target = event.target;
        const value = target.type === "select" ? target.selected : target.value;
        // const value = target.type === 'datetime' ? target.Datetime : target.value;
        const name = target.name;
        this.setState({
            [name]: value,
        });
    };

    onnotificationchange = (event) => {
        const target = event.target;
        const value = target.type === "select" ? target.selected : target.value;
        // const value = target.type === 'datetime' ? target.Datetime : target.value;
        const name = target.name;
        this.setState({
            [name]: value,
        });
    };

    onpaymentchange = (event) => {
        const target = event.target;
        const value = target.type === "select" ? target.selected : target.value;
        // const value = target.type === 'datetime' ? target.Datetime : target.value;
        const name = target.name;
        this.setState({
            [name]: value,
        });
        if (name == "paidamount") {
            var total_amunt = "";
            var paid_amount = "";
            var p_paid_amount = "";
            if (this.state.p_paid_amount == "" || this.state.p_paid_amount == null) {
                p_paid_amount = 0;
            } else {
                p_paid_amount = this.state.p_paid_amount;
            }
            total_amunt =
                parseFloat(this.state.p_total_cost) - parseFloat(p_paid_amount);
            // paid_amount =  parseFloat(value)
            var remain_amount = 0;
            if (value == "") {
                paid_amount = 0;
            } else {
                paid_amount = parseFloat(value);
            }
            remain_amount = parseFloat(total_amunt) - parseFloat(paid_amount);
            remain_amount = remain_amount.toFixed(2);
            this.setState({ remainpaymentamount: remain_amount });
        }
    };

    resetSearch() {
        this.setState({ deliverydate: new Date() });
        var deliverydate = new Date();
        this.searchData(deliverydate);
    }

    async editOrder(cus, channel) {
        if (channel == "app") {
            var token = JSON.parse(localStorage.getItem("user"));
            const obj = token.token;
            var review = "1";
            await Updatereview(cus, review, obj).then((res) => {
                console.log(res, "update view order ");
            });
        }
        this.props.history.push("/admin/order/" + cus);
    }

    searchdata(e) {
        this.setState({ page: "", isdaterangepickerOpen: false });
        this.searchData(this.state.deliverydate);
    }

    searchData(deliverydate) {
        var token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;

        this.setState({ noRecordFound: false });
        this.setState({ loading: true }, () => {
            searchUpcomingOrders(
                this.state.datarange.start.format("YYYY-MM-DD"),
                this.state.datarange.end.format("YYYY-MM-DD"),
                obj
            )
                .then((response) => {
                    var data = response.data;
                    if (data.data.length == 0) {
                        this.setState({ noRecordFound: true });
                    }
                    var $no_pages = [];
                    let serach_url = "";
                    let order_chk = [];
                    let serach_string = "";
                    for (var i = 1; i <= data.last_page; i++) {
                        if (serach_string == "") {
                            $no_pages.push(i);
                        } else {
                            $no_pages.push(i);
                        }
                    }
                    if (data.current_page == data.last_page) {
                        this.setState({ prevdisabled: null });
                        this.setState({ nextdisabled: "1" });
                    } else if (data.current_page == 1) {
                        this.setState({ nextdisabled: null });
                        this.setState({ prevdisabled: "1" });
                    } else {
                        this.setState({ nextdisabled: null });
                        this.setState({ prevdisabled: null });
                    }
                    if (data.last_page == 1) {
                        this.setState({ nextdisabled: 1 });
                        this.setState({ prevdisabled: 1 });
                    }
                    if (data.data.length == 0) {
                        $no_pages = [];
                        this.setState({ nextdisabled: 1 });
                        this.setState({ prevdisabled: 1 });
                    }
                    this.setState({ currentPage: data.current_page });
                    if (data.next_page_url != null) {
                        if (serach_string == "") {
                            this.setState({
                                nextpage: data.next_page_url.substring(
                                    data.next_page_url.indexOf("=") + 1
                                ),
                            });
                        } else {
                            this.setState({
                                nextpage: data.next_page_url.substring(
                                    data.next_page_url.indexOf("=") + 1
                                ),
                            });
                        }
                    } else {
                        this.setState({ nextpage: "#" });
                    }
                    if (data.prev_page_url != null) {
                        if (serach_string == "") {
                            this.setState({
                                prevpage: data.prev_page_url.substring(
                                    data.prev_page_url.indexOf("=") + 1
                                ),
                            });
                        } else {
                            this.setState({
                                prevpage: data.prev_page_url.substring(
                                    data.prev_page_url.indexOf("=") + 1
                                ),
                            });
                        }
                    } else {
                        this.setState({ prevpage: "#" });
                    }
                    this.setState({ paginationData: $no_pages });
                    response.data.data.map((ele) => {
                        ele["isChecked"] = false;
                        order_chk.push(ele);
                    });
                    this.setState({
                        order_details: response.data,
                        loading: false,
                    });
                    this.setState({
                        order_chk: order_chk,
                    });
                })
                .catch((error) => {
                    this.handleNetworkError("bl", error);
                });

            get_express_pending_order(obj).then((res) => {
                const data = res.data;

                this.setState({
                    express_data: data,
                });
            });
            get_normal_pending_order(obj).then((res) => {
                const data = res.data;

                this.setState({
                    normal_data: data,
                });
            });
        });
    }

    handleNetworkError(position, error) {
        var color = Math.floor(Math.random() * 4 + 1);
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        level = "error";
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
        <div>
          {getApiErrorMessage(error)}
        </div>
      ),
            level: level,
            position: position,
            autoDismiss: 15,
        });
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        this.searchData(this.state.deliverydate);

        this.interval = setInterval(() => this.searchData(), 180000);

        this.setState({
            useraccess: token.role,
        });

        getb2b(obj).then((res) => {
            this.setState({ b2bDetails: res.data.data });
        });
        let role = 5;

        getallrider(role, obj).then((res) => {
            const data = res.data;
            var array1 = this.state.rider_details;
            var array2 = array1.concat(data);
            this.setState({
                rider_details: array2,
            });

            let riderItems = [];
            this.state.rider_details.map((x, i) => {
                riderItems.push({ value: x.id, label: x.name });
            });
            this.setState({
                rider_data: riderItems,
            });
        });

        getallCurrier(10, obj).then((res) => {
            const data = res.data;

            var array1 = this.state.currier_details;
            var array2 = array1.concat(data);

            this.setState({
                currier_details: array2,
            });

            let currierItems = [];
            this.state.currier_details.map((x, i) => {
                currierItems.push({ value: x.id, label: x.name });
            });
            this.setState({
                currier_data: currierItems,
            });
        });

        getCity(obj, 1).then((res) => {
            this.setState({ city_info: res.data });
        });

        get_express_pending_order(obj).then((res) => {
            const data = res.data;

            this.setState({
                express_data: data,
            });
        });

        get_normal_pending_order(obj).then((res) => {
            const data = res.data;

            this.setState({
                normal_data: data,
            });
        });



    }

    sendNotification(id, total_cost, paid_amount) {
        this.setState({
            p_orderid: id,
            shownotificationmodal: true,
        });
    }

    paymentdetail(id, total_cost, paid_amount) {
        this.setState({
            p_total_cost: "",
            remainpaymentamount: "0",
            paymenttype: "",
            paidamount: "0",
        });
        var p_check_a = "";
        if (paid_amount == null) {
            p_check_a = 0;
        } else {
            p_check_a = paid_amount;
        }
        var r_amount = parseFloat(total_cost) - parseFloat(p_check_a);
        r_amount = r_amount.toFixed(2);
        // total_cost = total_cost.toFixed(2);
        this.setState({
            showpaymentdetailmodal: true,
            p_orderid: id,
            p_total_cost: total_cost,
            p_paid_amount: paid_amount,
            remainpaymentamount: r_amount,
        });
    }

    closepaymentdetailmodal() {
        this.setState({ showpaymentdetailmodal: false, errormessages: [] });
    }

    closeNotificationmodal() {
        this.setState({ shownotificationmodal: false, errormessages: [] });
    }

    submitpaymentdetail() {
        this.setState({ errormessages: [] });
        var token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        var total_amunt = "";
        var paid_amount = "";
        if (this.state.paymenttype == "2") {
            total_amunt = this.state.p_total_cost;
            paid_amount = parseFloat(this.state.paidamount);
            paid_amount = paid_amount.toFixed(2);
        } else if (this.state.paymenttype == "1") {
            paid_amount = "0";
        }
        updatepaymentinfo(
            this.state.paymenttype,
            paid_amount,
            this.state.p_orderid,
            obj
        )
            .then((res) => {
                if (res.data.success == true) {
                    this.setState({ loading: true });
                    this.setState({ showpaymentdetailmodal: false });
                    this.componentDidMount();
                } else if (res.data.success == false) {
                    if (res.data.data.length != 0) {
                        var ermessage = [];
                        for (var key of Object.keys(res.data.data)) {
                            var data = res.data.data[key];
                            ermessage.push(data);
                        }
                        this.setState({ errormessages: ermessage });
                        this.setState({ showpaymentdetailmodal: true });
                    } else {
                        this.handleClick("bl");
                    }
                }
            })
            .catch((res) => {
                console.log(res);
            });
        //   updatepaymentinfo(this.state.paymenttype,paid_amount,this.state.p_orderid,obj)
        //   .then(res => {
        //     console.log(res)
        //     if(res.data.success == true)
        //     {
        //     this.setState({ loading: true });
        //     this.componentDidMount();
        //     }
        //   })
        //   .catch(res => {
        //     console.log(res);
        //   })
        // }
        // this.setState({ showpaymentdetailmodal: false });
    }

    submitNotificationModal() {
        this.setState({
            processing: true,
        });
        var token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        sendNotificationSMS(this.state.p_orderid, this.state.notificationtype, obj)
            .then((res) => {
                this.setState({
                    shownotificationmodal: false,
                });
                this.hideAlert();

                this.setState({
                    showSmsMessageModal: true,
                    smsMessage: res.data.message,
                    processing: false,
                });

                this.searchData(this.state.deliverydate);
            })
            .catch((error) => {
                this.handleNetworkError("bl", error);
            });
    }

    handleDateChange = (date) => {
        this.setState({
            deliverydate: date,
        });
    };

    onSelect = (datarange, states) => {
        this.setState({
            datarange,
            states,
            isdatepickeron: !this.state.isdatepickeron,
            delivery_from_date: this.state.datarange.start.format("YYYY-MM-DD"),
            delivery_to_date: this.state.datarange.end.format("YYYY-MM-DD"),
        });
    };

    onToggle = () => {
        this.setState({ isdatepickeron: !this.state.isdatepickeron });
    };

    render() {
        const view = <Tooltip id="view">View Profile</Tooltip>;
        const edit = <Tooltip id="edit">Edit</Tooltip>;
        const payment = <Tooltip id="payment">Complete Order</Tooltip>;
        const quote = <Tooltip id="quote">Quote</Tooltip>;
        const remove = <Tooltip id="remove">Remove</Tooltip>;
        const charge = <Tooltip id="charge">Charge</Tooltip>;
        const notification = <Tooltip id="remove">Send PN / SMS</Tooltip>;
        const leadInfo = (props) => (
            <Tooltip id="button-tooltip" {...props}>
                Simple tooltip
            </Tooltip>
        );
        const errormessages = this.state.errormessages;
        const order_details = this.state.order_details;
        const order_data = this.state.order_chk;
        const order_status_arr = {
            1: "Submitted",
            2: "Processing",
            3: "Dispatched",
            4: "Completed",
            5: "Cancelled",
            6: "Attempted",
            7: "Unreachable",
            8: "Payment Pending",
            9: "Quote Sent",
            10: "Review",
            11: "Packed",
            12: "Ready",
        };
        const order_source_arr = {
            1: "Flash",
            2: "oPharma",
            3: "MyPharma",
            4: "Daraz",
            5: "Pickme",
            6: "E-channeling",
            7: "Uber",
        };
        const order_delivery_type = { 1: "Normal", 2: "Express" };
        var c = 1;
        return (
            <div className="main-content">
                {this.state.pdfloading ? <LoadingPdfSpinner /> : ""}
                <Grid fluid>
                    {this.state.alert}
                    <NotificationSystem ref="notificationSystem" style={style} />
                    <Row>
                        <Col className="fl_orderlist" md={12}>
                            <Card
                                tableFullWidth
                                content={
                                    <React.Fragment>
                                        <Row>
                                            <Col xs={12} sm={12} md={12} lg={12}>
                                                <Row
                                                    className="OrderList_fill"
                                                    style={{
                                                        borderRadius: "5px",
                                                        paddingTop: "10px",
                                                        paddingBottom: "10px",
                                                        width: "98%",
                                                        marginLeft: "7px",
                                                    }}
                                                >
                                                    <Col
                                                        md={8}
                                                        sm={8}
                                                        lg={8}
                                                        xs={12}
                                                        className="fl_mb_1 fl_datepicker"
                                                        style={{ width: "100%", paddingTop: "4px" }}
                                                    >
                                                        <FormGroup
                                                            className="fl_datepicker"
                                                            style={{ width: "50%" }}
                                                        >
                                                            <br></br>
                                                            <div
                                                                style={{ position: "relative", bottom: "5px" }}
                                                            >
                                                                <ControlLabel
                                                                    style={{
                                                                        marginTop: "1px",
                                                                        borderTop: "5px",
                                                                    }}
                                                                >
                                                                    {" "}
                                                                    Delivery Date Range
                                                                </ControlLabel>
                                                                <div className="delevirydaterange">
                                                                    <Button
                                                                        style={{ marginTop: "3px" }}
                                                                        value="Toggle date picker"
                                                                        onClick={this.onToggle.bind(this)}
                                                                    >
                                                                        Date Range
                                                                    </Button>
                                                                    <div>
                                                                        {this.state.datarange.start.format(
                                                                            "YYYY-MM-DD"
                                                                        )}
                                                                        {" - "}
                                                                        {this.state.datarange.end.format(
                                                                            "YYYY-MM-DD"
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                {this.state.isdatepickeron && (
                                                                    <DateRangePicker
                                                                        className="deliverydaterangepicker"
                                                                        value={this.state.datarange}
                                                                        onSelect={this.onSelect}
                                                                        singleDateRange={true}
                                                                    />
                                                                )}
                                                            </div>
                                                        </FormGroup>
                                                    </Col>

                                                    <Col
                                                        md={1}
                                                        sm={1}
                                                        lg={1}
                                                        xs={12}
                                                        className="fl_mb_1"
                                                        style={{
                                                            paddingRight: "5px",
                                                            marginTop: "5px",
                                                        }}
                                                    >
                                                        <Button
                                                            class="btn-color"
                                                            style={{ width: "100%" }}
                                                            // width="25%"  //bsStyle="info"
                                                            fill
                                                            onClick={this.searchdata.bind(this)}
                                                        >
                                                            Filter
                                                        </Button>
                                                        &nbsp;
                                                    </Col>
                                                    <Col
                                                        md={1}
                                                        sm={1}
                                                        lg={1}
                                                        xs={12}
                                                        className="fl_mb_1"
                                                        style={{
                                                            paddingRight: "5px",
                                                            marginTop: "5px",
                                                        }}
                                                    >
                                                        <Button
                                                            class="btn-color"
                                                            style={{ width: "100%" }} //bsStyle="info"
                                                            fill
                                                            onClick={this.resetSearch.bind(this)}
                                                        // width="25%"
                                                        >
                                                            Reset
                                                        </Button>
                                                    </Col>
                                                </Row>
                                                <br></br>

                                                <Col md={12} sm={12} lg={12} xs={12}>
                                                    <Table responsive>
                                                        <thead>
                                                            <tr>
                                                                {/*<th>
                                                                    <input
                                                                        type="checkbox"
                                                                        onClick={this.handleAllChecked}
                                                                        value="checkedall"
                                                                    />{" "}
                                                                 </th>*/}
                                                                <th></th>
                                                                <th>#Id</th>
                                                                <th>Subscriber</th>
                                                                <th>Order Date</th>
                                                                <th>Total Cost</th>
                                                                <th>Source</th>
                                                                <th>Status</th>
                                                                <th>Rider Name</th>
                                                                <th>Pending Amount</th>
                                                                <th>Payment Type</th>
                                                                <th>Pending Status</th>
                                                                {/* 
                     <th>View Quote</th>
                     */}
                                                                <th>Invoice</th>
                                                                <th className="text-right">Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.loading ? (
                                                                <tr>
                                                                    <td colSpan="10">
                                                                        <LoadingSpinner />
                                                                    </td>
                                                                </tr>
                                                            ) : this.state.noRecordFound ? (
                                                                <tr>
                                                                    <td colSpan="10">
                                                                        <center>No record found</center>
                                                                    </td>
                                                                </tr>
                                                            ) : (
                                                                <React.Fragment>
                                                                    {order_data.map((cus, key) => (
                                                                        <tr
                                                                            key={key}
                                                                            className={
                                                                                cus.is_viewed_by_admin == "0"
                                                                                    ? "red_background"
                                                                                    : ""
                                                                            }
                                                                        >
                                                                            {/*<td>
                                                                                <input
                                                                                    key={cus.id}
                                                                                    onClick={
                                                                                        this.handleCheckChieldElement
                                                                                    }
                                                                                    type="checkbox"
                                                                                    checked={cus.isChecked}
                                                                                    value={cus.id}
                                                                                />{" "}
                                                                                </td>*/}
                                                                            <td>
                                                                                {cus.channel == "app" ? (
                                                                                    <i
                                                                                        className="fa fa-mobile"
                                                                                        style={{ fontSize: "25px" }}
                                                                                    ></i>
                                                                                ) : (
                                                                                    ""
                                                                                )}
                                                                                {cus.channel == "flash_consult" ? (
                                                                                    <i
                                                                                        className="fa fa-user"
                                                                                        style={{ fontSize: "25px" }}
                                                                                    ></i>
                                                                                ) : (
                                                                                    ""
                                                                                )}
                                                                            </td>
                                                                            <td>{cus.id}</td>
                                                                            <td
                                                                                style={{ textTransform: "capitalize" }}
                                                                            >
                                                                                {cus.lead.name.toLowerCase()}
                                                                            </td>
                                                                            <td>{cus.created_at}</td>
                                                                            <td>{(cus.total_cost - 0).toFixed(2)}</td>
                                                                            <td className="no-padding">
                                                                                {order_source_arr[cus.source]}
                                                                            </td>
                                                                            {cus.order_status == 1 ||
                                                                                cus.order_status == 2 ||
                                                                                cus.order_status == 3 ? (
                                                                                <td className="">
                                                                                    <p className="btn btn-fill fl_text_orange">
                                                                                        {order_status_arr[cus.order_status]}
                                                                                    </p>
                                                                                </td>
                                                                            ) : cus.order_status == 4 ? (
                                                                                <td className="">
                                                                                    <p className="btn btn-fill fl_text_green ">
                                                                                        {" "}
                                                                                        {order_status_arr[cus.order_status]}
                                                                                    </p>
                                                                                </td>
                                                                            ) : cus.order_status == 5 ||
                                                                                cus.order_status == 8 ? (
                                                                                <td
                                                                                    style={{ display: "inline-flex" }}
                                                                                    className=""
                                                                                >
                                                                                    <p className="btn btn-fill fl_text_red">
                                                                                        {order_status_arr[cus.order_status]}
                                                                                    </p>
                                                                                    {cus.order_status == "5" ? (
                                                                                        <i
                                                                                            className="fa fa-ban"
                                                                                            onClick={this.open_cancel_reason_display_Modal.bind(
                                                                                                this,
                                                                                                cus.cancel_reason
                                                                                            )}
                                                                                            title="Show Order Cancel reason "
                                                                                        ></i>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}
                                                                                </td>
                                                                            ) : cus.order_status == 9 ? (
                                                                                <td
                                                                                    style={{ display: "inline-flex" }}
                                                                                    className=""
                                                                                >
                                                                                    <p className="btn btn-fill ">
                                                                                        {order_status_arr[cus.order_status]}
                                                                                    </p>
                                                                                    {cus.order_status == "9" ? (
                                                                                        <a
                                                                                            className="fa fa-eye"
                                                                                            href={cus.short_url}
                                                                                            target="_blank"
                                                                                            title="Submit Quote"
                                                                                        ></a>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}
                                                                                </td>
                                                                            ) : cus.order_status == 12 ? (
                                                                                <td className="">
                                                                                    <p className="btn btn-fill fl_text_purple">
                                                                                        {order_status_arr[cus.order_status]}
                                                                                    </p>
                                                                                </td>
                                                                            ) : (
                                                                                <td className="">
                                                                                    <p className="btn btn-fill">
                                                                                        {order_status_arr[cus.order_status]}
                                                                                    </p>
                                                                                </td>
                                                                            )}
                                                                            <td>
                                                                                {cus.rider_id != null
                                                                                    ? cus.riderdetails != null
                                                                                        ? cus.riderdetails.name
                                                                                        : ""
                                                                                    : ""}
                                                                            </td>
                                                                            {cus.total_cost == "0" ? (
                                                                                <td>
                                                                                    {cus.order_status != "4"
                                                                                        ? (cus.total_cost - 0).toFixed(2)
                                                                                        : "-"}
                                                                                </td>
                                                                            ) : (
                                                                                <td>
                                                                                    {cus.order_status != "4"
                                                                                        ? (
                                                                                            cus.total_cost - cus.paid_amount
                                                                                        ).toFixed(2)
                                                                                        : "-"}
                                                                                </td>
                                                                            )}
                                                                            <td>{cus.paymentoption}</td>
                                                                            <td>{cus.payment_status}</td>
                                                                            {/* 
                        <td style={{'text-align':'center'}}>{cus.short_url == null ? '-' :<a className="btn btn-default "bsSize="xs" href={cus.short_url} target="_blank" >View</a>}</td>
                        */}
                                                                            <td>
                                                                                {" "}
                                                                                <Button //bsStyle="danger"
                                                                                    disabled={!this.state.processing}
                                                                                    onClick={this.downloadinvoice.bind(
                                                                                        this,
                                                                                        cus.id
                                                                                    )}
                                                                                >
                                                                                    View
                                                                                </Button>
                                                                            </td>
                                                                            <td className="td-actions text-right no-padding">
                                                                                {cus.payment_status == "failed" &&
                                                                                    cus.channel == "app" &&
                                                                                    cus.paymentoption == "Card" &&
                                                                                    cus.source == 1 && (
                                                                                        <OverlayTrigger
                                                                                            placement="top"
                                                                                            overlay={charge}
                                                                                        >
                                                                                            <Button
                                                                                                simple
                                                                                                disabled={
                                                                                                    this.state.chargeProcessing
                                                                                                }
                                                                                                bsStyle="success"
                                                                                                bsSize="xs"
                                                                                                onClick={this.warningWithChargeMessage.bind(
                                                                                                    this,
                                                                                                    cus.id
                                                                                                )}
                                                                                            >
                                                                                                <i className="fa fa-address-card" />
                                                                                            </Button>
                                                                                        </OverlayTrigger>
                                                                                    )}
                                                                                <OverlayTrigger
                                                                                    placement="top"
                                                                                    overlay={notification}
                                                                                >
                                                                                    <Button
                                                                                        simple
                                                                                        bsStyle="info"
                                                                                        bsSize="xs"
                                                                                        onClick={this.sendNotification.bind(
                                                                                            this,
                                                                                            cus.id,
                                                                                            cus.total_cost,
                                                                                            cus.paid_amount
                                                                                        )}
                                                                                    >
                                                                                        <i className="fa  fa-bell"></i>
                                                                                    </Button>
                                                                                </OverlayTrigger>
                                                                                <OverlayTrigger
                                                                                    placement="top"
                                                                                    // overlay={leadInfo}
                                                                                    overlay={
                                                                                        <Tooltip id="button-tooltip">
                                                                                            {`${cus.lead.mobile_no}`}
                                                                                            <br />
                                                                                            {`${cus.address.address_line1}`}{" "}
                                                                                            {cus.address.address_line2 != null
                                                                                                ? cus.address.address_line2
                                                                                                : ""}
                                                                                            <br /> <b>Delivery Type</b> :
                                                                                            {cus.delivery_type == 1
                                                                                                ? "Normal"
                                                                                                : "Express"}
                                                                                        </Tooltip>
                                                                                    }
                                                                                >
                                                                                    <Button
                                                                                        simple
                                                                                        bsStyle="info"
                                                                                        bsSize="xs"
                                                                                    >
                                                                                        <i className="fa fa-info-circle" />
                                                                                    </Button>
                                                                                </OverlayTrigger>
                                                                                {cus.order_status != "4" ? (
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={payment}
                                                                                    >
                                                                                        <Button
                                                                                            simple
                                                                                            bsStyle="info"
                                                                                            bsSize="xs"
                                                                                            onClick={this.paymentdetail.bind(
                                                                                                this,
                                                                                                cus.id,
                                                                                                cus.total_cost,
                                                                                                cus.paid_amount
                                                                                            )}
                                                                                        >
                                                                                            <i className="fa fa-check-square-o" />
                                                                                        </Button>
                                                                                    </OverlayTrigger>
                                                                                ) : (
                                                                                    ""
                                                                                )}
                                                                                <OverlayTrigger
                                                                                    placement="top"
                                                                                    overlay={edit}
                                                                                >
                                                                                    <Button
                                                                                        simple
                                                                                        bsStyle="success"
                                                                                        onClick={this.editOrder.bind(
                                                                                            this,
                                                                                            cus.id,
                                                                                            cus.channel
                                                                                        )}
                                                                                        bsSize="xs"
                                                                                    >
                                                                                        <i className="fa fa-pencil" />
                                                                                    </Button>
                                                                                </OverlayTrigger>
                                                                                {this.state.useraccess == 1 && (
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={remove}
                                                                                    >
                                                                                        <Button
                                                                                            simple
                                                                                            bsStyle="danger"
                                                                                            onClick={this.warningWithConfirmAndCancelMessage.bind(
                                                                                                this,
                                                                                                cus.id
                                                                                            )}
                                                                                            bsSize="xs"
                                                                                        >
                                                                                            <i className="fa fa-times" />
                                                                                        </Button>
                                                                                    </OverlayTrigger>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </React.Fragment>
                                                            )}
                                                        </tbody>
                                                    </Table>
                                                    {this.state.loading ? (
                                                        ""
                                                    ) : this.state.noRecordFound ? (
                                                        ""
                                                    ) : (
                                                        <div style={{ textAlign: "center" }}>
                                                            <Pagination>
                                                                {!this.state.prevdisabled ? (
                                                                    <Pagination.First
                                                                        dataUrl={this.state.prevpage}
                                                                        onClick={this.getdata.bind(
                                                                            this,
                                                                            this.state.prevpage
                                                                        )}
                                                                        disabled={this.state.prevdisabled}
                                                                    />
                                                                ) : (
                                                                    ""
                                                                )}
                                                                {this.state.paginationData.map((url, key) => (
                                                                    <Pagination.Item
                                                                        key={key}
                                                                        dataUrl={url}
                                                                        active={
                                                                            this.state.currentPage == c ? "1" : null
                                                                        }
                                                                        onClick={this.getdata.bind(this, url)}
                                                                    >
                                                                        {c++}
                                                                    </Pagination.Item>
                                                                ))}
                                                                {!this.state.nextdisabled ? (
                                                                    <Pagination.Last
                                                                        dataUrl={this.state.nextpage}
                                                                        onClick={this.getdata.bind(
                                                                            this,
                                                                            this.state.nextpage
                                                                        )}
                                                                        disabled={this.state.nextdisabled}
                                                                    />
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </Pagination>
                                                        </div>
                                                    )}
                                                </Col>
                                                <Modal
                                                    show={this.state.show_charge_message}
                                                    onHide={() =>
                                                        this.setState({ show_charge_message: true })
                                                    }
                                                >
                                                    <Modal.Body>
                                                        <p> {this.state.charge_message} </p>
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button
                                                            bsStyle="success"
                                                            fill
                                                            onClick={() =>
                                                                this.setState({ show_charge_message: false })
                                                            }
                                                        >
                                                            OK
                                                        </Button>
                                                    </Modal.Footer>
                                                </Modal>
                                                <Modal
                                                    show={this.state.showpaymentdetailmodal}
                                                    onHide={() =>
                                                        this.setState({
                                                            showpaymentdetailmodal: false,
                                                            errormessages: [],
                                                        })
                                                    }
                                                >
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>Payment Details</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <form>
                                                            {errormessages.length != 0 && (
                                                                <div className=" alert alert-danger">
                                                                    {errormessages.map((data, key) => (
                                                                        <React.Fragment key={key}>
                                                                            <li>{data}</li>
                                                                        </React.Fragment>
                                                                    ))}
                                                                </div>
                                                            )}
                                                            <FormGroup className="order_source_data">
                                                                <ControlLabel>Payment type</ControlLabel>
                                                                &nbsp;
                                                                <Radio
                                                                    number="5"
                                                                    option="1"
                                                                    name="paymenttype"
                                                                    onChange={this.onpaymentchange}
                                                                    checked={this.state.paymenttype === "1"}
                                                                    label="Paid in full"
                                                                />
                                                                &nbsp;
                                                                <Radio
                                                                    number="6"
                                                                    option="2"
                                                                    name="paymenttype"
                                                                    onChange={this.onpaymentchange}
                                                                    checked={this.state.paymenttype === "2"}
                                                                    label="Partial Payment"
                                                                />
                                                            </FormGroup>
                                                            {this.state.paymenttype == "2" ? (
                                                                <>
                                                                    {this.state.p_paid_amount != null &&
                                                                        this.state.paymenttype == "2" ? (
                                                                        <p>
                                                                            Paid Amount :{" "}
                                                                            <b>
                                                                                {" "}
                                                                                {(this.state.p_paid_amount - 0).toFixed(
                                                                                    2
                                                                                )}{" "}
                                                                            </b>{" "}
                                                                        </p>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                    {this.state.remainpaymentamount != "0" &&
                                                                        this.state.paymenttype == "2" ? (
                                                                        <p>
                                                                            {" "}
                                                                            Pending Amount :{" "}
                                                                            <b>
                                                                                {" "}
                                                                                {(
                                                                                    this.state.remainpaymentamount - 0
                                                                                ).toFixed(2)}{" "}
                                                                            </b>{" "}
                                                                        </p>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                    {this.state.p_total_cost != "0" &&
                                                                        this.state.paymenttype == "2" ? (
                                                                        <p>
                                                                            {" "}
                                                                            Total Amount :{" "}
                                                                            <b>
                                                                                {" "}
                                                                                {(this.state.p_total_cost - 0).toFixed(
                                                                                    2
                                                                                )}{" "}
                                                                            </b>{" "}
                                                                        </p>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                    <FormGroup>
                                                                        <ControlLabel>Amount</ControlLabel>
                                                                        <FormControl
                                                                            type="number"
                                                                            min={0}
                                                                            value={this.state.paidamount}
                                                                            onChange={this.onpaymentchange}
                                                                            name="paidamount"
                                                                            placeholder="0.00"
                                                                        ></FormControl>
                                                                    </FormGroup>
                                                                </>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </form>
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button
                                                            bsStyle="danger"
                                                            fill
                                                            onClick={this.closepaymentdetailmodal.bind(this)}
                                                        >
                                                            Close
                                                        </Button>
                                                        <Button
                                                            bsStyle="success"
                                                            fill
                                                            onClick={this.submitpaymentdetail.bind(this)}
                                                        >
                                                            Submit
                                                        </Button>
                                                    </Modal.Footer>
                                                </Modal>
                                                <Modal
                                                    show={this.state.shownotificationmodal}
                                                    onHide={() =>
                                                        this.setState({ shownotificationmodal: true })
                                                    }
                                                >
                                                    <Modal.Header>
                                                        <Modal.Title>
                                                            Send Push Notification / SMS
                                                        </Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <p>
                                                            <FormGroup className="order_source_data">
                                                                <ControlLabel>Notification type</ControlLabel>
                                                                &nbsp;
                                                                <Radio
                                                                    number="11"
                                                                    option="delay"
                                                                    name="notificationtype"
                                                                    onChange={this.onnotificationchange}
                                                                    checked={
                                                                        this.state.notificationtype === "delay"
                                                                    }
                                                                    label="Order delay"
                                                                />
                                                                &nbsp;
                                                                <Radio
                                                                    number="12"
                                                                    option="reminder"
                                                                    name="notificationtype"
                                                                    onChange={this.onnotificationchange}
                                                                    checked={
                                                                        this.state.notificationtype === "reminder"
                                                                    }
                                                                    label="Payment Reminder"
                                                                />
                                                            </FormGroup>
                                                        </p>
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button
                                                            onClick={this.warningWithSendNotification.bind(
                                                                this
                                                            )}
                                                            bsStyle="success"
                                                            fill
                                                        >
                                                            Send Notification
                                                        </Button>
                                                        &nbsp;
                                                        <Button
                                                            bsStyle="danger"
                                                            fill
                                                            onClick={this.closeNotificationmodal.bind(this)}
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </Modal.Footer>
                                                </Modal>
                                                <Modal
                                                    show={this.state.showSmsMessageModal}
                                                    onHide={() =>
                                                        this.setState({ showSmsMessageModal: true })
                                                    }
                                                >
                                                    <Modal.Body>
                                                        <p> {this.state.smsMessage} </p>
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button
                                                            bsStyle="success"
                                                            fill
                                                            onClick={() =>
                                                                this.setState({ showSmsMessageModal: false })
                                                            }
                                                        >
                                                            OK
                                                        </Button>
                                                    </Modal.Footer>
                                                </Modal>
                                                <Modal
                                                    show={this.state.cancel_reason_display_Modal}
                                                    onHide={() =>
                                                        this.setState({ cancel_reason_display_Modal: true })
                                                    }
                                                >
                                                    <Modal.Header>
                                                        <Modal.Title>Order Cancel</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <p>
                                                            Cancel Reason : {this.state.Cancel_reason_state}{" "}
                                                        </p>
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button
                                                            bsStyle="danger"
                                                            fill
                                                            onClick={this.close_cancel_reason_display_Modal.bind(
                                                                this
                                                            )}
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </Modal.Footer>
                                                </Modal>
                                            </Col>
                                        </Row>
                                    </React.Fragment>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}
export default upcomingOrder;
